import { cloneObject, makeEdge, makeNodeDot } from "../utils/utils";
import JSZip from "jszip";


export const addDataSpec = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadDataSpec(Data)

    dsd.httpConfig.post(`/dataspecs`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
}

export const editDataSpec = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadDataSpec(Data)

    dsd.httpConfig.put(`/dataspecs/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

function payloadDataSpec(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.status = data.status;
    payload.Serialisation = data.Serialisation;

    return payload;

}

function dataDataSpec(data){

    let obj = data;

    return obj;

}

export const getDataSpec = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/dataspecs/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const listDataSpecs = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/dataspecs"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    if (Filters.idInterface){
        urlAPI += `idInterface=${encodeURIComponent(Filters.idInterface)}&`;
    }
    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataDataSpec(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};

export const getDataSpecVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/dataspecs/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const addSerializationToDataSpec = (dsd, idDataSpec, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = makeSerializationPayload(Data)

    dsd.httpConfig.post(`/dataspecs/${idDataSpec}/serializations`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
}


export const editSerialization = (dsd, id, Data = {}, onUpdate, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = makeSerializationPayload(Data)
    let idDataSpec = null;
    if (Data.DataSpec) {
        idDataSpec = Data.DataSpec._id;
    }

    dsd.httpConfig.put(`/dataspecs/${idDataSpec}/serializations/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};


export const deleteSerialization = (dsd, idDataSpec, id, onDelete, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/dataspecs/${idDataSpec}/serializations/${id}`, headers)
        .then(response => {
            if (onDelete){
                onDelete();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;

}


function makeSerializationPayload(inData){

    let data = cloneObject(inData)

    let payload = {}
    payload.name = data.name;
    payload.Root = data.Root;

    payload.description = data.description;
    payload.proposals = data.proposals;

    return payload;

}

export const getSerialization = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/serializations/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );


};
export const getSerializationVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/serializations/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const listSerializations = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/serializations"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.idDataSpec){
        urlAPI += `idDataSpec=${encodeURIComponent(Filters.idDataSpec)}&`;
    }

    if (Filters.idInterface){
        urlAPI += `idInterface=${encodeURIComponent(Filters.idInterface)}&`;
    }

 
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
               arr.push(makeSerializationData(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};



function makeSerializationData(data){

    let obj = data;

    return obj;

}


export const getSerializationJsonSchema = (dsd, id, onLoad, onFail) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    return(
        dsd.httpConfig.get(`/serializations/${id}?format=jsonschema`, headers)
            .then(response => {
                if (onLoad){
                    onLoad(response.data);
                }
            })
            .catch(e => {
                if (onFail){
                    onFail(e)
                }
            })
    );

    return;

};

export const getSerializationXSD = (dsd, id, onLoad, onFail) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    return(
        dsd.httpConfig.get(`/serializations/${id}?format=XSD`, headers)
            .then(response => {
                if (onLoad){
                    onLoad(response.data);
                }
            })
            .catch(e => {
                if (onFail){
                    onFail(e)
                }
            })
    );

    return;

};

export const zipDataSpec = async function(dsd, DataSpec){

    const zip = new JSZip();

    let Promises = [];

    let Version = null;
    let idVersion = null;
    if (DataSpec.Version){
        Version = DataSpec.Version;
        idVersion = Version._id;
    }

    let nameFolder = `dataspec_${DataSpec._id}`;
    if (Version){
        nameFolder += `_version_${idVersion}`;
    }

    let strDataSpec = JSON.stringify(DataSpec, null, 4);
    zip.file(`${nameFolder}/dsd.json`, strDataSpec);

    const listClasses = {};
    const listSerializations = {};

    const dotClasses = {};
    const dotSerializations = {};
    const jsonSchemaSerializations = {};
    const xsdSerialisations = {};

    for (const dsClass of DataSpec.Classes){
        const Class = cloneObject(dsClass);

        Class.DataSpec = cloneObject(DataSpec);
        delete Class.DataSpec.Classes;
        delete Class.DataSpec.Serializations;

        listClasses[Class._id] = Class;

        const onDone = function(reply){
            dotClasses[Class._id] = reply;
            return;
        };

        Promises.push(getClassVersion(dsd,Class._id,idVersion, onDone, null,'dot'));

    }

    for (const dsSerialization of DataSpec.Serializations){
        const Serialization = cloneObject(dsSerialization);

        Serialization.DataSpec = cloneObject(DataSpec);
        delete Serialization.DataSpec.Classes;
        delete Serialization.DataSpec.Serializations;

        listSerializations[Serialization._id] = Serialization;

        const onDoneDot = function(reply){
            dotSerializations[Serialization._id] = reply;
            return;
        };

        Promises.push(getSerializationVersion(dsd,Serialization._id,idVersion, onDoneDot, null,'dot'));

        const onDoneJsonSchema = function(reply){
            jsonSchemaSerializations[Serialization._id] = reply;
            return;
        };

        Promises.push(getSerializationVersion(dsd,Serialization._id,idVersion, onDoneJsonSchema, null,'jsonschema'));

        const onDoneXsd = function(reply){
            xsdSerialisations[Serialization._id] = reply;
            return;
        };

        Promises.push(getSerializationVersion(dsd,Serialization._id,idVersion, onDoneXsd, null,'xsd'));


    }

    return(
        Promise.all(Promises)
        .then(async response => {

            for (const idClass in listClasses){
                const Class = listClasses[idClass];
                
                const strClass = JSON.stringify(Class,null,4);
                zip.file(`${nameFolder}/classes/${Class._id}/dsd.json`, strClass);

                const dotClass = dotClasses && dotClasses[Class._id];
                if (dotClass) zip.file(`${nameFolder}/classes/${Class._id}/viz.dot`, dotClass);

            }

            for (const idSerialization in listSerializations){
                const Serialization = listSerializations[idSerialization];
                
                const strSerialization = JSON.stringify(Serialization,null,4);
                zip.file(`${nameFolder}/serializations/${Serialization._id}/dsd.json`, strSerialization);

                const dotSerialization = dotSerializations && dotSerializations[Serialization._id];
                if (dotSerialization) zip.file(`${nameFolder}/serializations/${Serialization._id}/viz.dot`, dotSerialization);

                const jsonSchemaSerialization = jsonSchemaSerializations && jsonSchemaSerializations[Serialization._id];
                if (jsonSchemaSerialization) zip.file(`${nameFolder}/serializations/${Serialization._id}/jsonschema.json`,  JSON.stringify(jsonSchemaSerialization, null, 4));

                const xsdSchemaSerialization = xsdSerialisations && xsdSerialisations[Serialization._id];
                if (xsdSchemaSerialization) zip.file(`${nameFolder}/serializations/${Serialization._id}/xsd.xsd`,  xsdSchemaSerialization, null, 4);

            }


            const zipData = await zip.generateAsync({
                type: "blob",
                streamFiles: true,
            })
        
            return zipData;    

        })
    )

};

// Class utility functions

function payloadClass(data){
    let payload = {};
    payload.name = data.name;
    payload.sourceType = data.sourceType;
    payload.description = data.description;
    payload.proposals = data.proposals;

    if (data.idEntity){
        payload.idEntity = data.idEntity;
    }
    if (data.idRelationship){
        payload.idRelationship = data.idRelationship;
    }

    if (data.Properties){
        payload.Properties = data.Properties;
    }

    payload.status = data.status;

    return payload;
}

function dataClass(data){
    return data;
}

export const addClassToDataSpec = (dsd, idDataSpec, Data = {}, onAdd, onError) => {

    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadClass(Data);

    dsd.httpConfig.post(`/dataspecs/${idDataSpec}/classes`, payload, headers)
       .then(response => {
           if (onAdd){
               onAdd(response.data._id)
           }
       })
       .catch(e => {
           if (onError){
               onError(e)
           }
       });
};

export const editClass = (dsd, id, Data = {}, onUpdate, onError) => {

    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadClass(Data);
    let idDataSpec = null;
    if (Data.DataSpec) {
        idDataSpec = Data.DataSpec._id;
    }

    dsd.httpConfig.put(`/dataspecs/${idDataSpec}/classes/${id}`, payload, headers)
       .then(response => {
           if (onUpdate){
               onUpdate();
           }
       })
       .catch(e => {
           if (onError){
               onError(e)
           }
       });
};

export const deleteClass = (dsd, idDataSpec, id, onDelete, onError) => {

    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/dataspecs/${idDataSpec}/classes/${id}`, headers)
        .then(response => {
            onDelete();
        })
       .catch(e => {
           if (onError){
               onError(e)
           }
       });
};

export const getClass = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/classes/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );


};


export const getClassVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/classes/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const listClasses = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/classes";
    if (Object.keys(Filters).length > 0){
        urlAPI += "?";
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idDataSpec){
        urlAPI += `idDataSpec=${encodeURIComponent(Filters.idDataSpec)}&`;
    }

    if (Filters.idSubClass){
        urlAPI += `idSubClass=${encodeURIComponent(Filters.idSubClass)}&`;
    }

    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length; pos++){
                arr.push(dataClass(response.data[pos]));
            }
            if (onLoad){ onLoad(arr); }
        })
        .catch(e => {
            if (onError){ onError(e); }
        });

    return;
};



export const makeElementGridNodes = (Node, Grid, dotNodes, seqChild=0) => {

    let arrIdNode = Node.idNode.split('_');
    let numRank = arrIdNode.length;
    if (!(`${numRank}` in Grid.Ranks)){
        Grid.Ranks[`${numRank}`] = {'num':numRank, Rows:[]};
    }
    let Rank = Grid.Ranks[`${numRank}`];

    let Row = {};
    Row.Node = Node;
    Row.num = Grid.maxRow;
    if (seqChild){
        Row.num++;
    }
    Rank.Rows.push(Row);

    Grid.maxRow = Row.num;

    if (Node.ChildNodes){
        let seq=0
        for (let idChildNode in Node.ChildNodes){
            let ChildNode = Node.ChildNodes[idChildNode];
            makeElementGridNodes(ChildNode, Grid, dotNodes, seq);
            seq++;
        }

    }
    
};

export const makeElementListNode = (arrElements, idNode, dotNodes, dotEdges, depth=0, Key=null) => {

    let Node = {};

    Node.type = 'elementlist';
    Node.Data = arrElements;
    Node.idNode = idNode;

    Node.ChildNodes = {};

    dotNodes[Node.idNode] = Node;

    Node.Edges = [];

    Node.color = 'lightseagreen';

    if (Key){
        if (Key.color){
            Node.color = Key.color;
        }
    }


    Node.style = null;

    Node.height= null;
    Node.width= null;

    Node.shape = "plaintext";

    Node.label = `
        <<table border='0' cellborder='1' cellspacing='0'>`;


    if (arrElements.length > 0){
        Node.label += `
            <tr><td PORT='heading' bgcolor='${Node.color}'>Label</td><td bgcolor='${Node.color}'>Data Type</td><td bgcolor='${Node.color}'>Occurs</td></tr>`;

        for (let pos=0; pos<arrElements.length;pos++){
            const Element = arrElements[pos];

            let ElementLabel = null;
            let ElementType = 'field';
            let DataType = '';
            let Occurs = '';
            let Required = '';

            if (Element.name){
                ElementLabel = Element.name;
            }
            if (Element.label){
                ElementLabel = Element.label;
            }


            if (Element.dataType){
                DataType = Element.dataType;
            }
            if (Element.occurs){
                Occurs = Element.occurs;
            }
            if (Element.required){
                Required = Element.required;
            }


            if (Element.Children){
                if (Element.Children.length){
                    ElementType = 'object';
                }
            }



            let Port = idNode;
            if (Element._id){
                Port = `element_${Element._id}`;
            }

            Node.label += `
            <tr><td align='left' balign='left' valign='top'>${ElementLabel}</td><td align='left' balign='left' valign='top'>${DataType}</td><td PORT='${Port}' align='left' balign='left' valign='top'>${Occurs}</td></tr>`;


            let ChildElements = [];

            if (Element.Properties){
                if (Element.Properties.length){
                    ChildElements = ChildElements.concat(Element.Properties);
                }
            }

            if (Element.Class){
                if (Element.Class.Properties){
                    if (Element.Class.Properties.length){
                        ChildElements = ChildElements.concat(Element.Class.Properties);
                    }
                }
            }


            if (Element.Children){
                if (Element.Children.length){
                    ChildElements = ChildElements.concat(Element.Children);
                }
            }
    
            if (ChildElements.length){
                let idChildNode = `${idNode}_${pos}`;
                Node.ChildNodes[idChildNode] = makeElementListNode(ChildElements, idChildNode, dotNodes, dotEdges, depth=0, Key=Key);
                let idEdge = idChildNode;
                let EdgeAtts = '';


                switch (Occurs){
                    case "many":
                        EdgeAtts = `arrowhead=crow arrowtail=none`
                        break;
                    case "once":
                    default:
                        EdgeAtts = `arrowhead=tee arrowtail=none`
                        break;
                }


                dotEdges[idEdge] = makeEdge('', dotNodes[idNode], dotNodes[idChildNode], 'solid', 'tail', 100, 10, EdgeAtts, Port, 'heading')
            }

        }
    }

    Node.label += `
        </table>> 
    `;


    return Node;

};


export const makeClassGrid = (Node, Grid, dotNodes, seqChild=0) => {

    let arrIdNode = Node.idNode.split('_');
    let numRank = arrIdNode.length;
    if (!(`${numRank}` in Grid.Ranks)){
        Grid.Ranks[`${numRank}`] = {'num':numRank, Rows:[]};
    }
    let Rank = Grid.Ranks[`${numRank}`];

    let Row = {};
    Row.Node = Node;
    Row.num = Grid.maxRow;
    if (seqChild){
        Row.num++;
    }
    Rank.Rows.push(Row);

    Grid.maxRow = Row.num;

    if (Node.ChildNodes){
        let seq=0
        for (let idChildNode in Node.ChildNodes){
            let ChildNode = Node.ChildNodes[idChildNode];
            makeClassGrid(ChildNode, Grid, dotNodes, seq);
            seq++;
        }

    }
    
};